// import components
import { Button } from '@mui/material';
import { MenuItems } from './MenuItems';

// import constants
import { WHITE } from 'constants/colors';

// import hooks
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// import types
import { SwitcherComponentProps } from '../../types';
import { StyledBoxFlexAlignStart } from 'components/shared/Box/Box.styles';
import { Icon } from '@sdb/planning-ui';

const SwitcherComponent = ({
  tabulatedItems,
  tabbedElement,
  setTabbedElement,
  page,
  disableRouting = false,
  showCustomMenuItemLabel = false
}: SwitcherComponentProps) => {
  const { t } = useTranslation('common');

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <StyledBoxFlexAlignStart>
      <Button
        variant="outlined"
        sx={{
          bgcolor: WHITE
        }}
        onClick={handleClick}
        endIcon={<Icon type="chevron-down" sx={{ ml: 1 }} />}
      >
        {showCustomMenuItemLabel
          ? t(`${tabbedElement.label}`)
          : t(`tableTabs.${tabbedElement.name}`)}
      </Button>
      <MenuItems
        open={open}
        componentName={tabbedElement.name}
        handleClose={handleClose}
        tabulatedItems={tabulatedItems}
        anchorEl={anchorEl}
        setTabbedElement={setTabbedElement}
        page={page}
        disableRouting={disableRouting}
        showCustomMenuItemLabel={showCustomMenuItemLabel}
      />
    </StyledBoxFlexAlignStart>
  );
};

export default SwitcherComponent;
